import { ACTIONS } from './constants'

// Actions
export const setCompraClickProduct = (compraClick) => ({
  type: ACTIONS.SET_COMPRA_CLICK_PRODUCT,
  compraClick
})
